<h3>{{ "PAGES.REGISTRATION-CATEGORIES" | translate }}</h3>
<hr class="divider" />

<div style="min-height: 200px" [nbSpinner]="loading">
    <ng-container *ngIf="category">
        <div class="mb-4">
            <h5>{{ category.descricao }}</h5>
            <span class="d-block mb-2">{{ "GENERAL.SUBSCRIBE-UNTIL" | translate }} {{ category.inscrever_ate }}</span>
            <span class="d-block">{{ "GENERAL.CANCEL-UNTIL" | translate }}: {{ category.cancelar_ate }}</span>
        </div>
        <div class="category-partner__tip" *ngIf="category.tipo_categoria === '2'">
            <nb-icon icon="alert-circle-outline" status="info"></nb-icon>
            <p class="paragraph-1">Para finalizar sua inscrição na categoria, selecione uma dupla</p>
        </div>
        <div class="mb-4 mb-lg-5" *ngIf="category.tipo_categoria === '2'">
            <label class="label">{{ "GENERAL.FIND-PARTNER" | translate }}</label>

            <app-autocomplete
                (search)="search($event)"
                (selected)="addPartner($event)"
                [result]="result$"
                [loading]="searching"
            ></app-autocomplete>
        </div>

        <div class="row">
            <div class="col-lg-6" *ngFor="let confirmation of confirmations; let index = index">
                <nb-card>
                    <nb-card-header>
                        <strong>{{ confirmation.nome_completo }}</strong> <br />
                        <span>{{ confirmation.email }}</span>
                    </nb-card-header>
                    <!-- TODO: FIX-ME. Estruturas diferentes -->
                    <nb-card-body *ngIf="confirmation.status_code === 0 || confirmation.nome_uf">
                        <div *ngIf="confirmation.nome_uf">
                            <p class="d-flex justify-content-between align-items-center mb-2">
                                <strong>{{ "USER.UF" | translate }}</strong
                                ><span>{{ confirmation.nome_uf }}</span>
                            </p>
                            <p class="d-flex justify-content-between align-items-center mb-2">
                                <strong>{{ "USER.CITY" | translate }}</strong
                                ><span>{{ confirmation.nome_cidade }}</span>
                            </p>
                            <p class="d-flex justify-content-between align-items-center mb-2">
                                <strong>{{ "USER.COUNTRY" | translate }}</strong
                                ><span>{{ confirmation.nome_pais }}</span>
                            </p>
                        </div>
                        <div *ngIf="confirmation.valores">
                            <p class="d-flex justify-content-between align-items-center mb-2">
                                <strong>{{ "PAYMENT.CREDIT-AMOUNT" | translate }}</strong
                                ><span
                                    >{{ confirmation.valores.simbolo_moeda }}
                                    {{ confirmation.valores.valor_credito }}</span
                                >
                            </p>
                            <p class="d-flex justify-content-between align-items-center mb-2">
                                <strong>{{ "PAYMENT.DISCOUNT-AMOUNT" | translate }}</strong
                                ><span
                                    >{{ confirmation.valores.simbolo_moeda }}
                                    {{ confirmation.valores.valor_desconto }}</span
                                >
                            </p>
                            <p class="d-flex justify-content-between align-items-center mb-2">
                                <strong>{{ "PAYMENT.EXEMPTION-AMOUNT" | translate }}</strong
                                ><span
                                    >{{ confirmation.valores.simbolo_moeda }}
                                    {{ confirmation.valores.valor_isencao }}</span
                                >
                            </p>
                            <p class="d-flex justify-content-between align-items-center mb-2">
                                <strong>{{ "PAYMENT.NET-AMOUNT" | translate }}</strong
                                ><span
                                    >{{ confirmation.valores.simbolo_moeda }}
                                    {{ confirmation.valores.valor_liquido }}</span
                                >
                            </p>
                            <p class="d-flex justify-content-between align-items-center">
                                <strong>{{ "PAYMENT.TOTAL-AMOUNT" | translate }}</strong
                                ><span
                                    >{{ confirmation.valores.simbolo_moeda }}
                                    {{ confirmation.valores.valor_total }}</span
                                >
                            </p>
                        </div>
                    </nb-card-body>
                    <nb-card-footer *ngIf="confirmation.status_code === 1">
                        <p class="text-danger" [innerHTML]="confirmation.message"></p>
                        <button
                            nbButton
                            size="small"
                            status="primary"
                            *ngIf="
                                 confirmation?.filiacao &&
                                !confirmation.filiacao?.[index + 1]?.anuidadeEmDia &&
                                !confirmation.filiacao?.[index + 1]?.isentaAnuidade
                            "
                            [routerLink]="['/user/affiliations-type']"
                        >
                            {{ "AFFILIATIONS.NEW-AFFILIATION" | translate }}

                            <nb-icon icon="arrow-forward-outline"></nb-icon>
                        </button>
                    </nb-card-footer>
                </nb-card>
            </div>
        </div>
        <nb-alert class="my-2" [status]="alert.status" closable *ngIf="alert.show">
            {{ alert.message }}
        </nb-alert>
        <div class="d-flex justify-content-center">
            <button nbButton (click)="back()" class="mr-3">{{ "BUTTONS.BACK-TOURNAMENT" | translate }}</button>
            <button nbButton (click)="enrollTournament()" status="primary" [disabled]="!canEnroll">
                {{ "BUTTONS.CONFIRM-REGISTRATION" | translate }}
            </button>
        </div>
    </ng-container>
</div>
